module.exports = __webpack_public_path__ + "static/media/plan_de_activitate_casa_maria.b7865f83.pdf";